export default __webpack_public_path__ + "static/media/GothamSSm-ExtraLight.5a10bce4.svg";